import { render } from "./Faculty.vue?vue&type=template&id=21d2018d&scoped=true"
import script from "./Faculty.vue?vue&type=script&lang=js"
export * from "./Faculty.vue?vue&type=script&lang=js"

import "./Faculty.vue?vue&type=style&index=0&id=21d2018d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d2018d"]])

export default __exports__